import page from './page.json';
import img from './img.json';

import guide from './page/guide.json';

export default {
  page,
  img,
  guide,
};
